import React from "react"

const ResourcesTable = () => {
  return (
    <div className="resources-table">
      <div className="resources-table__inner">
        <div className="resources-table__description">
          <p>Table 3.1</p>
          <h4>Budget by Major Expenditure Category, FY 2021–24</h4>
          <p>&#40;millions of US dollars&#41;</p>
        </div>

        {/* Start table */}
        <div className="resources-table__data">
          <table>
            <thead>
              <tr>
                <th></th>
                <th>FY 2021 Budget</th>
                <th>FY 2021 Outturn</th>
                <th>FY 2022 Budget</th>
                <th>FY 2022 Outturn</th>
                <th>FY 2023 Budget</th>
                <th>FY 2024 Budget</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="table--bold">Administrative expenditures</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td class="resources-table--indent">Personnel</td>
                <td>1,055</td>
                <td>1,049</td>
                <td>1,074</td>
                <td>1,106</td>
                <td>1,158</td>
                <td>-</td>
              </tr>
              <tr>
                <td class="resources-table--indent">Travel</td>
                <td>133</td>
                <td>16</td>
                <td>134</td>
                <td>26</td>
                <td>122</td>
                <td>-</td>
              </tr>
              <tr>
                <td class="resources-table--indent">Buildings and other</td>
                <td>230</td>
                <td>203</td>
                <td>239</td>
                <td>214</td>
                <td>265</td>
                <td>-</td>
              </tr>
              <tr>
                <td class="resources-table--indent">Contingency</td>
                <td>11</td>
                <td>-</td>
                <td>12</td>
                <td>-</td>
                <td>13</td>
                <td>-</td>
              </tr>
              <tr className="table--bold">
                <td>Total gross expenditures</td>
                <td>1,429</td>
                <td>1,268</td>
                <td>1,460</td>
                <td>1,346</td>
                <td>1,559</td>
                <td>1,641</td>
              </tr>
              <tr>
                <td class="resources-table--indent">Receipts¹</td>
                <td>-243</td>
                <td>-142</td>
                <td>-246</td>
                <td>-166</td>
                <td>-264</td>
                <td>-282</td>
              </tr>
              <tr className="table--bold">
                <td>Total net budget</td>
                <td>1,186</td>
                <td>1,126</td>
                <td>1,214</td>
                <td>1,180</td>
                <td>1,295</td>
                <td>1,359</td>
              </tr>
              <tr>
                <td class="resources-table--indent">Carry forward²</td>
                <td>55</td>
                <td>-</td>
                <td>102</td>
                <td>-</td>
                <td>93</td>
                <td>-</td>
              </tr>
              <tr className="table--bold">
                <td>Total net budget including carry forward</td>
                <td>1,241</td>
                <td>1,126</td>
                <td>1,315</td>
                <td>1,180</td>
                <td>1,387</td>
                <td>1,359</td>
              </tr>
              <tr className="table--bold">
                <td>Total gross budget including carry forward</td>
                <td>1,484</td>
                <td>1,268</td>
                <td>1,561</td>
                <td>1,346</td>
                <td>1,651</td>
                <td>1,641</td>
              </tr>
              <tr className="table--bold">
                <td>Capital³</td>
                <td>99</td>
                <td>78</td>
                <td>79</td>
                <td>90</td>
                <td>78</td>
                <td>91</td>
              </tr>
              <tr>
                <td class="resources-table--indent">
                  Facilities and information technology
                </td>
                <td>99</td>
                <td>78</td>
                <td>70</td>
                <td>81</td>
                <td>63</td>
                <td>74</td>
              </tr>
              <tr>
                <td class="resources-table--indent">
                  Cloud Capital Equivalent (CCE) <br /> <i>Memorandum item</i>
                </td>
                <td>-</td>
                <td>-</td>
                <td>10</td>
                <td>9</td>
                <td>15</td>
                <td>17</td>
              </tr>
            </tbody>
            <tfoot>
              <tr className="table--bold">
                <td>Total net budget in FY 2022 dollars</td>
                <td>1,214</td>
                <td>1,152</td>
                <td>1,214</td>
                <td>1,180</td>
                <td>1,235</td>
                <td>1,267</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      {/* End table */}
      <p className="resources-table__source">
        Source: IMF, Office of Budget and Planning. <br />
        Note: Figures in columns may not sum exactly to column totals because of rounding.
        <br />
        <ol type="1">
          <li>
            Includes donor-financed activities, cost-sharing arrangements with
            the World Bank, sales of publications, parking, and other
            miscellaneous revenue.
          </li>
          <li>
            Resources are carried forward from the previous year under
            established rules.
          </li>
          <li>
            Facilities and information technology budget appropriations can be
            spent over three years. The “Budget” column represents the annual
            appropriation, whereas the “Outturn” column includes spending from
            appropriations of previous years.
          </li>
        </ol>
      </p>
    </div>
  )
}

export default ResourcesTable
